import styled from 'styled-components';

import { convertPxToRem } from '@proprioo/salatim';

export const AgentsCellLayout = styled.div`
  padding-top: ${convertPxToRem(6)};
`;
